module.exports = __webpack_public_path__ + "img/5.019a2959.jpg";